// Role for shop page
export const ROLE_TYPE = {
  ADMIN: 1,
  MERCHANT: 2,
  KOL: 4,
}

// Roles allowed to host a live room (開直播 entry)
export const hasLiveHostRole = (roles?: number[] | null) => Boolean(roles?.some((role) => role === ROLE_TYPE.KOL || role === ROLE_TYPE.MERCHANT))
